export default __webpack_public_path__ + "static/media/package.753da085.gif";